import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const VueRouterPush = Router.prototype.push ;
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}

export default new Router({
  routes: [{
    path: '/',
    redirect: '/home',
    name: 'home'
  },
  {
    path: '/',
    component: () => import('../components/common/Home.vue'),
    meta: {
      title: '自述文件'
    },
    children: [{
      path: '/dashboard',
      name: 'dashboard',
      component: () => import('../components/page/dashbord/Dashboard.vue'),
      meta: {
        title: '系统首页'
      }
    }, {
      path: '/test',
      name: 'test',
      component: () => import('../components/page/test/test.vue'),
      meta: {
        title: '测试'
      }
    }]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('../components/page/Login/Login.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../components/page/register/register.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../components/page/home/home.vue')
  },
  {
    path: '/researchdirection',
    name: 'researchdirection',
    meta: {
      title: '研究方向'
    },
    component: () => import('../components/page/researchdirection/researchdirection.vue')
  },
  {
    path: '/researchequipment',
    name: 'researchequipment',
    meta: {
      title: '科研设备'
    },
    component: () => import('../components/page/researchequipment/researchequipment.vue')
  },
  {
    path: '/dynamic',
    name: 'dynamic',
    meta: {
      title: '动态'
    },
    component: () => import('../components/page/dynamic/dynamic.vue')
  },
  {
    path: '/dynamicDetails',
    name: 'dynamicDetails',
    meta: {
      title: '动态详情'
    },
    component: () => import('../components/page/dynamicDetails/dynamicDetails.vue')
  },
  {
    path: '/researchProgressDetails',
    name: 'researchProgressDetails',
    meta: {
      title: '研究进展详情'
    },
    component: () => import('../components/page/researchProgressDetails/researchProgressDetails.vue')
  },
  {
    path: '/Researchprojectdetails',
    name: 'Researchprojectdetails',
    meta: {
      title: '科研项目详情'
    },
    component: () => import('../components/page/Researchprojectdetails/Researchprojectdetails.vue')
  },
  {
    path: '/equipmentdetails',
    name: 'equipmentdetails',
    meta: {
      title: '科研设备详情'
    },
    component: () => import('../components/page/equipmentdetails/equipmentdetails.vue')
  },
  {
    path: '/miendetails',
    name: 'miendetails',
    meta: {
      title: '组内风采详情'
    },
    component: () => import('../components/page/miendetails/miendetails.vue')
  },
  {
    path: '/ktzintroduce',
    name: 'ktzintroduce',
    meta: {
      title: '课题组介绍'
    },
    component: () => import('../components/page/ktzintroduce/ktzintroduce.vue')
  },
  // {
  //   path: '/yanjiujinzhanxiangqingye',
  //   name: 'yanjiujinzhanxiangqingye',
  //   meta: {
  //     title: '研究进展详情'
  //   },
  //   component: () => import('../components/page/yanjiujinzhanxiangqingye/yanjiujinzhanxiangqingye.vue')
  // },
  // {
  //   path: '/keyanxiangmuxiangqingye',
  //   name: 'keyanxiangmuxiangqingye',
  //   meta: {
  //     title: '科研项目详情'
  //   },
  //   component: () => import('../components/page/keyanxiangmuxiangqingye/keyanxiangmuxiangqingye.vue')
  // },
  {
    path: '/researchprogress',
    name: 'researchprogress',
    meta: {
      title: '研究进展' 
    },
    component: () => import('../components/page/researchprogress/researchprogress.vue')
  },
  {
    path: '/researchproject',
    name: 'researchproject',
    meta: {
      title: '科研项目'
    },
    component: () => import('../components/page/researchproject/researchproject.vue')
  },
  {
    path: '/teamintroduction',
    name: 'teamintroduction',
    meta: {
      title: '团队介绍'
    },
    component: () => import('../components/page/teamintroduction/teamintroduction.vue')
  },
  {
    path: '/principalIntroduce',
    name: 'principalIntroduce',
    meta: {
      title: '负责人介绍'
    },
    component: () => import('../components/page/principalIntroduce/principalIntroduce.vue')
  },
  {
    path: '/member/:id',
    name: 'member',
    meta: {
      title: '个人介绍'
    },
    component: () => import('../components/page/member/member.vue')
  }, 
  {
    path: '/upload',
    name: 'upload',
    meta: {
      title: '测试页面（可删）'
    },
    component: () => import('../components/page/upload/upload.vue')
  },
  {
    path: '/selfDefined/:menuType/:modelType',
    name: 'selfDefined',
    component: () => import('../components/page/contentConfig/selfDefined.vue'),
    meta: {
      title: '自定义页面'
    }
  }, 
  {
    path: '/404',
    name: '404',
    component: () => import('../components/error/404.vue')
  },
  {
    path: '/403',
    name: '403',
    component: () => import('../components/error/403.vue')
  }
  ],
  // scrollBehavior (to, from, savedPosition) {
  //   if (savedPosition) {
  //    return savedPosition
  //   } else {
  //    return { x: 0, y: 0 }
  //   }
  //   }member
});



// WEBPACK FOOTER //
// ./src/router/index.js